import { styled } from '@mui/material/styles';
import Card from '@components/Card';
import { Typography } from '@components/Typography';
import { ProfileName } from '@constants/integrations';
import { BRAND_TEAL } from '@constants/colors';

const CardAddress = styled('p', {
    shouldForwardProp: prop => prop !== 'disabled',
})(({ disabled }) => ({
    fontFamily: 'Rubik, sans-serif',
    fontWeight: 500,
    fontSize: 10,
    lineHeight: '12px',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    color: 'var(--text-secondary)',
    marginTop: 0,
    marginBottom: 8,
    ...(disabled && {
        color: 'var(--text-tertiary)',
    }),
}));

const generateAddress = addr => {
    return `${addr.address || ''}, ${addr.city || ''}, ${addr.postalCode || ''}, ${addr.country || ''}`;
};

const LocationCard = ({ location = {}, title, selectedLocation, setLocation, integrationType, integrationIdProp }) => {
    const isDisabled = location.connected;
    const isCoverManager = integrationType === ProfileName.CoverManager;

    return (
        <Card
            type="radio"
            selected={
                location[integrationIdProp] === selectedLocation[integrationIdProp] &&
                location.integrationId === selectedLocation.integrationId &&
                !isDisabled
            }
            title={title}
            value={location[integrationIdProp]}
            setValue={() => setLocation(location)}
            disabled={isDisabled}
        >
            {isCoverManager && <CardAddress disabled={isDisabled}>{generateAddress(location)}</CardAddress>}
            {isDisabled && (
                <Typography
                    variant="caption"
                    sx={{
                        color: '#fff',
                        backgroundColor: BRAND_TEAL,
                        padding: '2px 6px',
                        borderRadius: '18px',
                        width: 'fit-content',
                        marginTop: isCoverManager ? '16px' : 0,
                    }}
                >
                    {location.connectedLocationName}
                </Typography>
            )}
        </Card>
    );
};

export default LocationCard;
